type UrlInterceptor = (url: string) => boolean | Promise<boolean>;

const interceptors: UrlInterceptor[] = [];

export function registerUrlInterceptor(handler: UrlInterceptor): () => void {
  interceptors.push(handler);
  return () => {
    const idx = interceptors.indexOf(handler);
    if (idx !== -1) interceptors.splice(idx, 1);
  };
}

export async function runUrlInterceptors(url: string): Promise<boolean> {
  for (const interceptor of interceptors) {
    if (await interceptor(url)) return true;
  }
  return false;
}
